import type { FC } from 'react';

import { cn } from '@/lib/utils';

import { Title } from '@/components/atoms/Typography/Title';

import SelectMenu from './_components/SelectMenu/SelectMenu';
import normalizeName from './utils/normalizeName';
import type { IntegrationSideContentTemplateType } from './IntegrationSideContentTemplate.types';

import { INTEGRATION_MENU_SELECT_CONFIG_MOBILE } from '@/static/content/pl/integration/integration-side-content';

export interface IntegrationSideContentTemplateProps {
    listData: IntegrationSideContentTemplateType[];
    activeListItemId?: string;
}

const IntegrationSideContentTemplate: FC<
    IntegrationSideContentTemplateProps
> = ({ listData, activeListItemId }) => (
    <nav className="space-y-4 md:block md:min-w-[250px] lg:min-w-[350px] lg:max-w-[336px]">
        <SelectMenu mobileList={INTEGRATION_MENU_SELECT_CONFIG_MOBILE} />

        <div className="hidden md:block">
            {listData.map(({ id, title, list }) => (
                <div
                    key={id}
                    className="mb-8 space-y-2"
                >
                    <Title size="m">{title}</Title>

                    <ul className="space-y-1">
                        {list.map(({ id, name, Icon, iconProps, href }) => {
                            const normalizedIdName = normalizeName(name);
                            const isActive =
                                normalizedIdName === activeListItemId;

                            return (
                                <li key={id}>
                                    <a
                                        href={href}
                                        className={cn(
                                            'flex cursor-pointer items-center gap-x-4 py-2 text-typo-primary hover:text-green-600 md:pr-4',
                                            isActive &&
                                                'font-bold text-green-700',
                                        )}
                                        data-test-id={`integration-side-content-item-${id}`}
                                    >
                                        {!!Icon && (
                                            <Icon
                                                alt=""
                                                size={32}
                                                className="shrink-0"
                                                {...iconProps}
                                            />
                                        )}

                                        <span className="text-sm font-extrabold">
                                            {name}
                                        </span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    </nav>
);

export default IntegrationSideContentTemplate;
